import {withTranslation} from "react-i18next";
import {Button, makeStyles, Modal, Typography} from "@material-ui/core";
import {poolActions} from "../../../redux/actions/poolActions";
import React from "react";
import {useDispatch, useSelector} from "react-redux";
const logo = 'https://cdn.swapallapp.com/l2/images/rewardHeadImage.png'

const HarvestLiquidity = (props) => {
    const {
        onCancel: handleClose,
        modalVisible,
        values,
        t
    } = props;
    const useStyles = makeStyles((theme) => ({
        modal: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        paper: {
            position: 'absolute',
            width: 400,
            backgroundColor: theme.palette.background.paper,
            border: '2px solid #000',
            boxShadow: theme.shadows[5],
            padding: theme.spacing(2, 4, 3),
        }
    }));
    const classes = useStyles();
    const dispatch = useDispatch();
    const { token } = useSelector(state => state.auth)

    const handleSubmit = async () => {
        dispatch(poolActions.harvestLiquidityReward({
            pid: values.pid,
            token: values.token,
            accessToken: token
        }))
        if (values.token2 !== null){
            dispatch(poolActions.harvestLiquidityReward({
                pid: values.pid,
                token: values.token2,
                accessToken: token
            }))
        }
        handleClose()
    }
    const resultViewBody = (
        <div style={{
            backgroundColor: '#1A3279', borderRadius: 24, width: 480, outline: 0, alignItems: 'center', display: 'flex', flexDirection: 'column'
        }}>

            <img
                style={{ height: 325, width: 288, marginTop: -20 }}
                // alt='Travel Image'
                src={logo}
            />
            <Typography id="simple-modal-title"
                style={{ color: 'white', fontSize: 24, fontWeight: 'bold' }}
            >
                {t('pool-collectReward')}
            </Typography>
            <Typography
                style={{ color: '#8FB9E1', fontSize: 14, fontWeight: 'bold', marginBottom: 40,marginLeft:24,marginRight:24 ,marginTop:8}}
            >
                {t('pool-collectReward-confirmContent')}
            </Typography>
            <Button

                onClick={handleSubmit}
                style={{ backgroundColor: '#1ADA9A', width: "100%", height: 60, borderRadius: 0, borderBottomLeftRadius: 24, borderBottomRightRadius: 24 }}

            >
                <Typography style={{ fontSize: 16, fontWeight: 'bold', color: '#010846' }}>
                    {t('confirm')}
                </Typography>

            </Button>
        </div>
    );
    return (
        <Modal
            open={modalVisible}
            onClose={handleClose}
            className={classes.modal}
        >
            {resultViewBody}
        </Modal>
    )
}
export default withTranslation()(HarvestLiquidity);
